<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="visible" destroy-on-close title="请选择要加入的书单" width="800" :before-close="handleClose">
		<el-row class="book-main" :gutter="20">
			<el-col :span="8" v-for="book in bookList" :key="book.id" class="book-col" :class="{ selected: book.selected, 'already-had': book.isHad }" @click.native="selectBook(book.id)">
				<div class="book-item" :class="{ 'select-item': book.selected, 'already-had-item': book.isHad }">
					<span class="book-radio-wrap" v-if="!book.isHad"><el-radio v-model="selectedBookId" :label="book.id" :readonly="book.isHad" @click.native.stop="selectBook(book.id)"> </el-radio></span>
					<h6 class="book-name" :title="book.catalogName">{{ book.catalogName }}</h6>
					<el-tag v-if="book.isHad" type="success" class="had-indicator"> <span>已加入</span></el-tag>
				</div>
			</el-col>
		</el-row>
		<div v-if="total > pageSize" style="text-align: center; margin-top: 20px">
			<el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page.sync="pageNum" @current-change="handlePageChange"> </el-pagination>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="handleClose">取消</el-button>
				<el-button size="small" type="primary" @click="handleConfirm">提交</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
	import Y from '@/utils/Y';
	import { getPersonalBookList } from '@/api/book/personalBook';
	import TMessage from '@/utils/TMessage';

	export default {
		props: {
			standardId: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				visible: false,
				bookList: [],
				selectedBookId: null,
				pageNum: 1,
				pageSize: 15,
				total: 0
			};
		},
		watch: {
			visible: function (newVal, oldVal) {
				if (newVal) {
					this.pageNum = 1;
					this.selectedBookId = null;
					this.getMemberGetBookList(true);
				}
			}
		},
		methods: {
			getMemberGetBookList(isInitial = false) {
				getPersonalBookList({ catalogType: 2 }, this.pageNum, this.pageSize).then(res => {
					if (res.code == 200) {
						this.total = res.data.totalNum;
						if (res.data.rows.length > 0) {
							this.bookList = res.data.rows;
							// 初始化选中状态
							this.bookList.forEach(item => {
								item.selected = false;
							});
							// 仅在首次打开弹窗时默认选中第一项（跳过已加入的书单）
							if (isInitial) {
								const availableBooks = this.bookList.filter(book => !book.isHad);
								if (availableBooks.length > 0) {
									availableBooks[0].selected = true;
									this.selectedBookId = availableBooks[0].id;
								}
							}
						}
					} else {
						Y.msg.error(res.message);
					}
				});
			},

			handleClose() {
				this.visible = false;
				this.selectedBookId = null;
				this.pageNum = 1;
			},

			handlePageChange(pageNum) {
				this.pageNum = pageNum;
				this.selectedBookId = null;
				this.getMemberGetBookList(false);
			},

			// 选中书单的方法
			selectBook(bookId) {
				// 检查是否已加入，如果已加入则不允许选择
				const targetBook = this.bookList.find(book => book.id === bookId);
				if (targetBook && targetBook.isHad) {
					return; // 已加入的书单不允许选择
				}

				// 清除所有选中状态
				this.bookList.forEach(item => {
					item.selected = false;
				});

				// 设置当前项为选中状态
				const currentBook = this.bookList.find(book => book.id === bookId);
				if (currentBook && !currentBook.isHad) {
					currentBook.selected = true;
					this.selectedBookId = bookId;
				}
			},

			handleConfirm() {
				if (this.selectedBookId) {
					// 验证选中的书单是否已加入
					const selectedBook = this.bookList.find(book => book.id === this.selectedBookId);
					if (selectedBook && selectedBook.isHad) {
						TMessage.error('该书单已加入，请选择其他书单');
						return;
					}
					this.$emit('confirm', this.selectedBookId);
				} else {
					//如果书单都是isHad，提示用户都加入
					const allHad = this.bookList.every(book => book.isHad);
					if (allHad) {
						TMessage.warning('所有书单都已加入');
						return;
					} else {
						TMessage.error('请选择要加入的书单');
					}
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .el-radio__label {
		display: none;
	}

	/deep/ .el-radio {
		margin-right: 0;
	}

	/deep/ .el-dialog__header {
		border-bottom: 1px solid #e8e8e8;
		margin-right: 0;
		background: #f5f7fa;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #3a434f;
		font-size: 24px;
	}

	/deep/ .el-dialog__footer {
		border-top: 1px solid #e8e8e8;
		padding: 18px;
	}

	/deep/ .el-dialog__body .el-form-item__label {
		line-height: 26px;
	}
	.book-main {
		.book-col {
			.book-item {
				border-radius: 10px;
				cursor: pointer;
				margin: 0 0 20px 0;
				padding: 18px 20px;
				padding-left: 50px;
				border: 1px solid #e0e0e0;
				transition: all 0.3s;
				position: relative; // 为 radio 和已加入标识提供定位上下文
				display: flex;
				align-items: center;
				min-height: 48px;
			}

			.book-radio-wrap {
				position: absolute;
				left: 20px;
				top: 50%;
				transform: translateY(-50%);
				display: flex;
				align-items: center;
			}

			.book-name {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				line-clamp: 2;
				overflow: hidden;
				text-overflow: ellipsis;
				color: #333;
				font-size: 15px;	
				font-weight: 500;
				margin: 0;
				line-height: 1.5;
				word-break: break-all;
				width: 100%;
			}

			.select-item {
				border: 1px solid #1474e2;
				box-shadow: 0 0 5px rgba(20, 116, 226, 0.2);
			}

			// 已加入的书单样式
			.already-had-item {
				background-color: #fff;
				cursor: not-allowed;
				opacity: 0.7;
				padding-left: 20px;

				.book-name {
					color: #999;
					text-align: center;
				}
			}

			.had-indicator {
				position: absolute;
				// top: 50%;
				// transform: translateY(-50%);
				left: 0;
				top: -1px;
				// background-color: #67c23a;
				// color: white;
				// padding: 4px 8px;
				// border-radius: 4px;
				// font-size: 12px;
				display: flex;
				align-items: center;
				gap: 4px;

				i {
					font-size: 12px;
				}
			}
		}
	}
</style>
